import { render, staticRenderFns } from "./MentorProfile.vue?vue&type=template&id=c681c14a&scoped=true&"
import script from "./MentorProfile.vue?vue&type=script&lang=js&"
export * from "./MentorProfile.vue?vue&type=script&lang=js&"
import style0 from "./MentorProfile.vue?vue&type=style&index=0&id=c681c14a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c681c14a",
  null
  
)

export default component.exports